module.exports = __webpack_public_path__ + "img/icon-warning.78e8bf5b.svg";